export enum HttpMethod {
    get = 'GET',
    GET = 'GET',
    post = 'post',
    POST = 'POST',
    json = 'json',
    JSON = 'JSON',
}

export enum SocketPacketTypeEnum {
    PING = 'ping',
    MATCH = 'match',
    CHESS = 'chess',
    SPRINT = 'sprint',
    SPRINT_PK = 'sprintPK',
    FRIEND = 'friend',
    INVITE = 'invite',
    FRIEND_CHESS = 'friendChess',
}

// export enum SocketPacketCateEnum {
//     SUCCESS = 'success',
//     UPDATE = 'update',
//     COUNT_DOWN_TIME = 'countDownTime',
// }

export const SocketPacketCateMap = {
    MATCH: {
        SUCCESS: 'match.success'
    },
    CHESS: {
        UPDATE: 'chess.update', // 更新棋盘
        COUNTDOWN: 'chess.countdown',  // 倒计时
        TALK: 'chess.talk', // 弹幕
        BACK_REQUEST: 'chess.backRequest', // 申请悔棋
        BACK_RESPONSE: 'chess.backResponse', // 悔棋回应
        DRAW_REQUEST: 'chess.drawRequest', // 申请和棋
        DRAW_RESPONSE: 'chess.drawResponse', // 和棋回应
        GAME_CONFIG: 'chess.gameConfig', // 游戏配置
        OVER: 'chess.over', // 游戏结束
        /**
         * 邀请对弈
         */
        INVITE: 'chess.invite',
    },
    SPRINT: {
        TIME: 'sprint.time', // 更新时间
        END: 'sprint.end', // 通知结束
        POINT: 'sprint.goingPoint', // 分数变动
    },
    SPRINT_PK: {
        INVITE: 'sprintPk.invite', // 邀请好友
        JOIN: 'sprintPk.join', // 加入房间
        LEAVE: 'sprintPk.leave', // 离开房间
        REFUSE: 'sprintPk.refuse', // 拒绝邀请
        START: 'sprintPk.start', // 开始游戏
        COUNTDOWN: 'sprintPk.countdown', // 倒计时
        DISBAND: 'sprintPk.disband', // 解散房间
        END: 'sprintPk.end', // 结束游戏
        POINT_CHANGE: 'sprintPk.pointChange', // 积分改变
    },
    FRIEND: {
        INVITE_SUBJECT: 'friend.inviteSubject', // 好友邀请冲刺 PK
        /**
         * 好友申请
         */
        APPLY: 'friend.apply',
    },
    /**
     * 邀请好友对局
     */
    FRIEND_CHESS: {
        /**
         * 邀请
         */
        INVITE: "friendChess.invite",
        /**
         * 拒绝
         */
        REFUSE: "friendChess.refuse",
        /**
         * 接受
         */
        ACCEPT: "friendChess.accept",
        /**
         * 取消
         */
        CANCEL: "friendChess.cancel",
    }
}

export enum GameStatus {
    /**
     * 在线
     */
    ONLINE = 0,
    /**
     * 积分赛匹配中
     */
    MATCH = 1,
    /**
     * 对弈
     */
    IN_CHESS = 2,
    /**
     * 离线
     */
    OFFLINE = 4,
    /**
     * 冲刺 PK
     */
    IN_SPRINT_PK = 5,
    /**
     * 好友对弈
     */
    IN_FRIEND_CHESS = 6,
    /**
     * 锦标赛待匹配
     */
    WAIT_CHAMPIONSHIP_MATCH = 7,
    /**
     * 锦标赛匹配完成
     */
    CHAMPIONSHIP_MATCH_FINISH = 8,
    /**
     * 锦标赛匹配中
     */
    IN_CHAMPIONSHIP_MATCH = 9,
    /**
     * 锦标赛游戏中
     */
    IN_CHAMPIONSHIP = 10,
    /**
     * 战力赛待匹配
     */
    WAIT_ENTERTAINMENT_MATCH = 11,
    /**
     * 战力赛匹配完成
     */
    ENTERTAINMENT_MATCH_FINISH = 12,
    /**
     * 战力赛匹配中
     */
    IN_ENTERTAINMENT_MATCH = 13,
    /**
     * 战力赛游戏中
     */
    IN_ENTERTAINMENT = 14,
}